import "bootstrap/dist/css/bootstrap.min.css";
import "ckeditor5/ckeditor5.css";
import { Suspense, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./assets/styles/component.css";
import "./assets/styles/responsive.css";
import "./assets/styles/database.css";
import AddMachine from "./component/AddMachine";
import ChangePassword from "./component/Authflows/ChangePassword";
import ForgetPassword from "./component/Authflows/ForgetPassword";
import GitVerify from "./component/Authflows/GitVerify";
import LogIn from "./component/Authflows/LogIn";
import Otp2FA from "./component/Authflows/Otp2FA";
import OtpPage from "./component/Authflows/OtpPage";
import SignOtpPage from "./component/Authflows/SignOtpPage";



import SignUp from "./component/Authflows/SignUp";
import BillingAndCostManagement from "./component/BillingAndCostManagement";
import BillingAndCostManagementListing from "./component/BillingAndCostManagementListing";
import CompleteProfile from "./component/CompleteProfile";
import DevDashboard from "./component/Dev/DevDashboard";
import MyMachine from "./component/Dev/MyMachine";
import HandleNavigate from "./component/HandleNavigate";
import Layout from "./component/Layout";
import MachineReview from "./component/MachineReview";
import MachineReviewListing from "./component/MachineReviewListing";
import Marketplace from "./component/Marketplace";
import MarketPlaceDetail from "./component/MarketPlaceDetail";
import Machine360Analytics from "./component/Machine360Analytics";
import MarketPlaceDeveloper from "./component/MarketPlaceDeveloper";
import ProfileModule from "./component/MyProfile/ProfileModule";
import Mypurchase from "./component/Mypurchase";
import Projects from "./component/Projects";
import Sandboxs from "./component/Sandboxs";

import ProjectView from "./component/ProjectView";
import Schedular from "./component/Schedular";
import SchedularDetail from "./component/SchedularDetail";
import UpdateMachineVersion from "./component/UpdateMachineVersion";
import Dashboard from "./component/Workflow/Dashboard";
import DataNewFlowPage from "./component/Workflow/DataNewFlowPage";
import DataNewFlowViewPage from "./component/Workflow/DataNewFlowPageForView";
import { commonservices } from "./services/CommonServices";
import Announcements from "./component/Announcements";
import Announcement from "./component/Announcement";
import WorkflowTimeline from "./component/WorkFlowTimeLine";
import { DatabaseListing, DatabaseDetail, CreateDatabase } from "./component/Database";
import EKSNodeGroupListing from "./component/EKSNodeGroup/EKSNodeGroupListing";
import "react-phone-number-input/style.css";
import Sandbox from "./component/Workflow/Sandbox";

// import Contact from "./component/Workflow/Contact";

function App() {
    const Token = useSelector((state) => state.userinfo.Token);
    let Userdata = useSelector((state) => state?.userinfo?.UserInfo);
    const is_logged = Token !== null ? true : false;
    const checkUserIsReviewer = () => {
        let isReviewer = false;
        if (Userdata?.associationtype === "Reviewers") {
            isReviewer = true;
        }
        return isReviewer;
    };
    // const checkUserIsReviewer = () => {
    //   let isReviewer = false;
    //   if (Userdata?.associationtype === "Reviewers") {
    //     isReviewer = true;
    //   }
    //   return isReviewer;
    // };

    const userInfoData = commonservices.getItem("UserInfo");
    const userRoleRightData = commonservices.getItem("UserRoleRight");
    const organizationData = commonservices.getItem("Organization");

    const DevFlowRoutes = () => {
        return (
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route
                        path="/dashboard"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DevDashboard />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <ProfileModule />
                            </Suspense>
                        }
                    />
                    {/* <Route
            path="/marketplace"
            element={
              <Suspense fallback={"Loader..."}>
                <Marketplace />
              </Suspense>
            }
          /> */}
                    <Route
                        path="/marketplace"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Marketplace />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/addmachine"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <AddMachine />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/addmachine/:machineid"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <AddMachine />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/marketplace-detail/:id/:pagename"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MarketPlaceDetail />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/machine-360/:id/:pagename"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Machine360Analytics />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/machine-360/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Machine360Analytics />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/machine-360"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Machine360Analytics />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/developer"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MarketPlaceDeveloper />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/machine"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MyMachine />
                            </Suspense>
                        }
                    />

                    <Route
                        path="/complete-profile"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <CompleteProfile />
                            </Suspense>
                        }
                    />
                    {/* <Route
            path="/contact"
            element={
              <Suspense fallback={"Loader..."}>
                <Contact />
              </Suspense>
            }
          /> */}
                    <Route
                        path="/management-listing"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <BillingAndCostManagementListing />
                            </Suspense>
                        }
                    />
                    <Route
                        // path="/upgrade-version"
                        path="/marketplace/marketplace-detail/:id/update-version/:versionnumber"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <UpdateMachineVersion />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/my-purchase"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Mypurchase />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/workflowtimeline"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <WorkflowTimeline />
                            </Suspense>
                        }
                    />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        );
    };
    const ContactRoutes = () => {
        return (
            <Routes>
                <Route path="/" element={<Layout />}>
                    {window.location.origin === process.env.REACT_APP_DEV ? (
                        <>
                            <Route index element={<Navigate to="/dashboard" replace />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DevDashboard />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="/profile"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <ProfileModule />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Marketplace />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/management-listing"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <BillingAndCostManagementListing />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/addmachine"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <AddMachine />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/addmachine/:machineid"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <AddMachine />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/marketplace-detail/:id/:pagename"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <MarketPlaceDetail />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/machine-360/:id/:pagename"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Machine360Analytics />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/machine-360/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Machine360Analytics />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/machine-360"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Machine360Analytics />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/developer"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <MarketPlaceDeveloper />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/machine"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <MyMachine />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/complete-profile"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <CompleteProfile />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="/marketplace/marketplace-detail/:id/update-version/:versionnumber"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <UpdateMachineVersion />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/my-purchase"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Mypurchase />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/workflowtimeline"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <WorkflowTimeline />
                                    </Suspense>
                                }
                            />
                        </>
                    ) : (
                        <>
                            <Route index element={<Navigate to="/dashboard" replace />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Dashboard />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/profile"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <ProfileModule />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/workflows"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Projects />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/sandboxs"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Sandboxs />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="/database"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DatabaseListing />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/databases"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DatabaseListing />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/database/create"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <CreateDatabase />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/database/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DatabaseDetail />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/announcements"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Announcements />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/announcement"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Announcement />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/projects/project-view"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <ProjectView />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/scheduler"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Schedular />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/complete-profile"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <CompleteProfile />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/scheduler/schedular-detail"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <SchedularDetail />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/billing-and-cost-maangement"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <BillingAndCostManagement />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/management-listing"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <BillingAndCostManagementListing />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Marketplace />
                                    </Suspense>
                                }
                            />
                            <Route
                                // path="/marketplace/marketplace-detail/:id"
                                path="/marketplace/marketplace-detail/:id/:pagename"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <MarketPlaceDetail />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/machine-360/:id/:pagename"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Machine360Analytics />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/machine-360/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Machine360Analytics />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/machine-360"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Machine360Analytics />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/marketplace/developer"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <MarketPlaceDeveloper />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/flow/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DataNewFlowPage />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/flow-new/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DataNewFlowPage />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/flow-new-view/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <DataNewFlowViewPage />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/my-purchase"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <Mypurchase />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/workflowtimeline"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <WorkflowTimeline />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/eks-node-group"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <EKSNodeGroupListing />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/eks-node-group/create"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <EKSNodeGroupListing />
                                    </Suspense>
                                }
                            />
                            <Route
                                path="/eks-node-group/edit/:id"
                                element={
                                    <Suspense fallback={"Loader..."}>
                                        <EKSNodeGroupListing />
                                    </Suspense>
                                }
                            />
                        </>
                    )}
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        );
    };

    const WorkFlowRoutes = () => {
        if (checkUserIsReviewer()) {
            window.location.href = `${process.env.REACT_APP_DEV}/machine-review`;
            return;
        }
        return (
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route
                        path="/dashboard"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Dashboard />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <ProfileModule />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/workflows"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Projects />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/sandboxs"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Sandboxs />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/database"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DatabaseListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/databases"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DatabaseListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/database/create"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <CreateDatabase />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/database/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DatabaseDetail />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/announcements"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Announcements />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/announcement"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Announcement />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/projects/project-view"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <ProjectView />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/scheduler"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Schedular />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/complete-profile"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <CompleteProfile />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/scheduler/schedular-detail"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <SchedularDetail />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/billing-and-cost-maangement"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <BillingAndCostManagement />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/management-listing"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <BillingAndCostManagementListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Marketplace />
                            </Suspense>
                        }
                    />
                    <Route
                        // path="/marketplace/marketplace-detail/:id"
                        path="/marketplace/marketplace-detail/:id/:pagename"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MarketPlaceDetail />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/machine-360/:id/:pagename"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Machine360Analytics />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/machine-360/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Machine360Analytics />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/machine-360"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Machine360Analytics />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/marketplace/developer"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MarketPlaceDeveloper />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/flow/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DataNewFlowPage />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/flow-new/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DataNewFlowPage />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/sandbox/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Sandbox />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/flow-new-view/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <DataNewFlowViewPage />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/my-purchase"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <Mypurchase />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/workflowtimeline"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <WorkflowTimeline />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/eks-node-group"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <EKSNodeGroupListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/eks-node-group/create"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <EKSNodeGroupListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/eks-node-group/edit/:id"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <EKSNodeGroupListing />
                            </Suspense>
                        }
                    />
                    {/* <Route
            path="/contact"
            element={
              <Suspense fallback={"Loader..."}>
                <Contact />
              </Suspense>
            }
          /> */}
                </Route>
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        );
    };

    const ReviewerRoutes = () => {
        return (
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Navigate to="/machine-review" replace />} />
                    <Route
                        path="/machine-review/:id/:version"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MachineReview />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/management-listing"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <BillingAndCostManagementListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/machine-review"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <MachineReviewListing />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <ProfileModule />
                            </Suspense>
                        }
                    />
                </Route>
                <Route path="*" element={<Navigate to="/machine-review" />} />
            </Routes>
        );
    };

    const CompleteProfileRoutes = () => {
        return (
            <Routes>
                <Route path="/complete-profile" element={<Layout />}>
                    <Route
                        path="/complete-profile"
                        element={
                            <Suspense fallback={"Loader..."}>
                                <CompleteProfile />
                            </Suspense>
                        }
                    />
                </Route>
                <Route path="*" element={<Navigate to="/complete-profile" />} />
            </Routes>
        );
    };

    // const DomainWiseRoutes = () => {
    //   return window?.location.href.includes(`${process.env.REACT_APP_DEV}`) ? (
    //     checkUserIsReviewer() ? (
    //       <ReviewerRoutes />
    //     ) : Userdata?.isprofilecompleted ? (
    //       <DevFlowRoutes />
    //     ) : (
    //       <CompleteProfileRoutes />
    //     )
    //   ) : Userdata?.associationtype === "Contacts" ? (
    //     <WorkFlowRoutes />
    //   ) : Userdata?.isprofilecompleted ? (
    //     <WorkFlowRoutes />
    //   ) : (
    //     <CompleteProfileRoutes />
    //   );
    // };

    const DomainWiseRoutes = () => {
        // if (!organizationData || !userRoleRightData || !userInfoData) {
        //   commonservices.clearLocalStorage();
        //   window.location.reload();
        // }
        if (Userdata?.associationtype === "Contacts") {
            return <ContactRoutes />;
        }

        return window?.location.href.includes(`${process.env.REACT_APP_DEV}`) ? (
            checkUserIsReviewer() ? (
                <ReviewerRoutes />
            ) : Userdata?.isprofilecompleted ? (
                <DevFlowRoutes />
            ) : (
                <CompleteProfileRoutes />
            )
        ) : Userdata?.isprofilecompleted ? (
            <WorkFlowRoutes />
        ) : (
            <CompleteProfileRoutes />
        );
    };
    useEffect(() => {
        const handleStorageEvent = (event) => {
            if (event.key === "Token") {
                window.location.reload();
            }
        };

        window.addEventListener("storage", handleStorageEvent);
        return () => {
            window.removeEventListener("storage", handleStorageEvent);
        };
    }, []);
    const AuthRoutes = () => (
        <Routes>
            <Route path="/" element={<LogIn />} />
            <Route path="/otp" element={<OtpPage />} />

            <Route path="/authentication" element={<Otp2FA />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/sign-up-otp" element={<SignOtpPage />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/change-password/:id" element={<ChangePassword />} />
            <Route path="/git_verify/:code" element={<GitVerify />} />
            <Route path="/git_verify/" element={<GitVerify />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );

    const OthersRoutes = () => {
        // const is_logged = localStorage.getItem("Token") ? true : false;
        return <>{is_logged ? <DomainWiseRoutes /> : <AuthRoutes />}</>;
    };

    return (
        <div id="app" className="App">
            {/* <Router>{is_logged ? <AllRoutes /> : <AuthRoutes />}</Router> */}
            <Router>
                <Routes>
                    <Route path="/continue" element={<HandleNavigate />} />
                    <Route path="*" element={<OthersRoutes />} />
                </Routes>
            </Router>
            <ToastContainer />
        </div>
    );
}

export default App;
